import {connect} from 'react-redux';
import AddReviewerGroup, {AddReviewerGroupProps} from './AddReviewerGroup';
import ReviewerGroupModel from '../../types/ReviewerGroupModel';
import ReduxState from '../../types/ReduxState';

const mapStateToProps = (state: ReduxState, ownProps: AddReviewerGroupContainerProps): AddReviewerGroupProps => {
   const reviewerGroup: ReviewerGroupModel = ownProps.reviewerGroup || {GroupName: '', GroupMembers: [], Id: null};
   return {
      reviewerGroup: reviewerGroup,
      reviewerGroups: ownProps.reviewerGroups,
      onCancel: ownProps.onCancel,
      themeName: state.themeName,
      setHasPendingChanges: ownProps.setHasPendingChanges
   };
};

export default connect(mapStateToProps)(AddReviewerGroup);

interface AddReviewerGroupContainerProps {
   reviewerGroup: ReviewerGroupModel;
   reviewerGroups: ReviewerGroupModel[];
   onCancel(): void;
   setHasPendingChanges(hasPendingChanges: boolean): void;
}
